var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
      _vm._v(" "),
      _vm.resTitle
        ? _c("p", { staticClass: "is-size-5" }, [_vm._v(_vm._s(_vm.resTitle))])
        : _vm._e(),
      _vm.resBody ? _c("p", [_vm._v(_vm._s(_vm.resBody))]) : _vm._e(),
      _vm._v(" "),
      _vm.isActivePasswordInput
        ? _c(
            "b-field",
            {
              attrs: {
                label: _vm.$t("form.NewPassword"),
                type: _vm.checkEmpty(_vm.errors.password) ? "" : "is-danger",
                message: _vm.checkEmpty(_vm.errors.password)
                  ? ""
                  : _vm.errors.password[0],
              },
            },
            [
              _c("b-input", {
                attrs: {
                  type: "password",
                  "password-reveal": true,
                  icon: "lock",
                  "icon-pack": "fas",
                  placeholder: _vm.$t("common.password"),
                },
                on: {
                  blur: function ($event) {
                    return _vm.validate("password")
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.keyDownEnter($event)
                  },
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "control" }, [
          _c("button", {
            staticClass: "button is-primary",
            attrs: { disabled: _vm.isLoading },
            domProps: { textContent: _vm._s(_vm.$t("common.send")) },
            on: {
              click: function ($event) {
                return _vm.updatePassword()
              },
            },
          }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }